import { Label } from '@blueprintjs/core';
import { IData, QuerySelect } from '../QuerySelect';
import styles from './FilterSelect.module.css';
import { ReactNode } from 'react';

export function FilterSelect<T extends IData>({
  label,
  items,
  onSelect,
  value,
  description,
  stringify,
  disabled,
  filterable,
}: {
  label: string;
  items: T[];
  onSelect(item: T): void;
  value: T | undefined;
  description?: ReactNode;
  stringify(item: T): string;
  disabled?: boolean;
  filterable?: boolean;
}) {
  return (
    <Label className={styles.container}>
      <span className={styles.noWrap}>{label}</span>
      <QuerySelect<T>
        className={styles.buttonText}
        data={items}
        onSelect={onSelect}
        stringify={stringify}
        value={value}
        disabled={disabled}
        filterable={filterable}
      />
      <span className={styles.description}>{description}</span>
    </Label>
  );
}
